import { Component, Input } from '@angular/core';
import { BusStopSchema } from 'src/app/models/bus-stop-schema';
import { PackageRequest } from 'src/app/models/package-request';
import { ProgramsService } from 'src/app/services/programs.service';
import { WaitIndicatorService } from 'src/app/services/wait-indicator.service';

@Component({
  selector: 'app-info-enrollment',
  templateUrl: './info-enrollment.component.html',
  styleUrl: './info-enrollment.component.scss'
})
export class InfoEnrollmentComponent {
  @Input() public request!: PackageRequest;

  protected sport = '';
  protected level = '';
  protected program = '';
  protected busStop!: BusStopSchema
  constructor(
    private programService: ProgramsService,
    private waitIndicatorService: WaitIndicatorService,
  ) { }

  protected calculateAge = (birthDate: Date): number => {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const mountDif = today.getMonth() - birthDate.getMonth();
    const dayDif = today.getDate() - birthDate.getDate();
    if (mountDif < 0 || (mountDif === 0 && dayDif < 0)) {
      age--;
    }
    return age;
  }

  public load = async (id: string): Promise<void> => {
      this.waitIndicatorService.show();
      const data = await this.programService.packageRequestInfo(id);
      this.request = data.package;
      this.sport = data.sport ?? 'Няма избран спорт';
      this.level = data.level ?? 'Няма избрано ниво';
      this.program = data.program;
      this.busStop = data.busStop;
      this.waitIndicatorService.hide();
  }

  protected renderDates = (dates: Date[]): string => {
    return dates[0]?.toLocaleDateString('bg-BG');
  }

  protected renderHours = (time: string): string => {
    return `${time.slice(0, -2)}:${time.slice(-2)}`;
  }
}
